/**
 * Import all the `core-js` polyfills applicable to our lower common
 * denominators, IE 11 and Samsung Internet Browser 4. The blacklist
 * defined in the `exclude` option of the `.babelrc` acts as a filter
 * for what is ultimately included in the application bundle.
 */
import 'intersection-observer';

// DOM polyfills for IE 11
if (!Element.prototype.matches && Element.prototype.msMatchesSelector) {
    Element.prototype.matches = Element.prototype.msMatchesSelector;
}
